import React, { memo } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaDownload, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

// Logo importları (Kendi dosya yollarını kontrol et)
import logo from "../assets/icons/logo.png";
import logoo from "../assets/icons/mirasimlogo.png";

const Footer = () => {
  // Hızlı Erişim Linkleri
  const quickLinks = [
    { label: "Anasayfa", path: "/" },
    { label: "Projelerimiz", path: "/Projeler" },
    { label: "Kurumsal", path: "/Kurumsal" },
    { label: "Paketler & Üyelik", path: "/satinAl" },
    { label: "İletişim", path: "/İletisim" },
  ];

  // Yasal Linkler (Sozlesmeler.jsx içindeki KEY'ler ile aynı olmalı)
  const legalLinks = [
    { label: "Abonelik Sözleşmesi", path: "/sozlesme/abonelik" },
    { label: "Mesafeli Satış Sözleşmesi", path: "/sozlesme/mesafeli-satis" },
    { label: "Gizlilik ve Çerez Politikası", path: "/sozlesme/gizlilik" },
    { label: "İptal ve İade Koşulları", path: "/sozlesme/iptal-iade" },
    { label: "KVKK Aydınlatma Metni", path: "/sozlesme/kvkk" },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-content">

        {/* 1. SÜTUN: MARKA */}
        <div className="footer-brand-col">
          <Link to="/">
            <img src={logo} alt="STAI Logo" className="brand-logo" />
          </Link>
          <p className="brand-desc">
            Bilim ve teknoloji ile geleceği bugünden inşa ediyoruz. İşletmeniz ve kişisel varlıklarınız için akıllı çözümler.
          </p>
          <div className="social-icons">
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedin /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
          </div>
        </div>

        {/* 2. SÜTUN: HIZLI MENÜ */}
        <div className="footer-links-col">
          <h5 className="footer-heading">Hızlı Erişim</h5>
          <nav className="footer-nav-list">
            {quickLinks.map((item, index) => (
              <Link key={index} to={item.path} className="footer-link">
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* 3. SÜTUN: YASAL (SÖZLEŞMELER) */}
        <div className="footer-links-col">
          <h5 className="footer-heading">Yasal & Kurumsal</h5>
          <nav className="footer-nav-list">
            {legalLinks.map((item, index) => (
              <Link key={index} to={item.path} className="footer-link">
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* 4. SÜTUN: UYGULAMA TANITIM */}
        <div className="footer-app-col">
          <h5 className="footer-heading">Mirasım App</h5>
          <div className="app-promo-box">
            <img src={logoo} alt="Mirasım Logo" className="app-logo mb-3" />
            <p className="small-text mb-3">Miras süreçlerinizi cepten yönetin.</p>
            <div className="d-flex flex-column gap-2">
              <a href="https://play.google.com/store/apps/details?id=com.stai.mirasim" target="_blank" rel="noopener noreferrer" className="store-link">
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" height="40" />
              </a>
              <a href="https://apps.apple.com/us/app/miras%C4%B1m/id6759550556" target="_blank" rel="noopener noreferrer" className="store-link">
                <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" height="40" />
              </a>
            </div>
          </div>
        </div>

      </div>

      {/* ALT: TELİF HAKKI */}
      <div className="footer-copyright">
        <div className="copyright-text">
          &copy; {new Date().getFullYear()} STAİ BİLİŞİM. Tüm hakları saklıdır.
        </div>
        <div className="payment-icons">
          <span style={{ opacity: 0.6, fontSize: '0.8rem' }}>Güvenli Ödeme Altyapısı</span>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
